import React, { useContext, useState, useRef, useEffect } from 'react';
import { AppContext } from '~/providers/AppProvider';
import styled from 'styled-components';
import moment from 'moment';
import { useOnClickOutside } from '~/hooks/useOnClickOutside';
import { Trans } from '@lingui/react';
import { getFormattedDates } from '~/utils/dateUtils';
import { SearchMultiDaysCalendar } from '@boatsetter-backup/js-component-lib';

const DateInput = ({ setDateValue, inputRef, dateError }) => {
  const appCtx = useContext(AppContext);
  const calendarRef = useRef(null);

  const [selectedDates, setSelectedDates] = useState(undefined);
  const [renderedDate, setRenderedDate] = useState(selectedDates ? moment(selectedDates[0], 'YYYY-MM-DD') : moment());

  const [showCalendar, setShowCalendar] = useState(false);
  useOnClickOutside(calendarRef, () => {
    setShowCalendar(false);
  });

  useEffect(() => {
    if (dateError) {
      setShowCalendar(true);
    }
  }, [dateError]);

  const toggleCalendar = () => {
    setShowCalendar((prev) => !prev);
  };

  const handleDateClick = (date) => {
    const currentDates = selectedDates || [];
    const newDates = [];
    let isDateInArr = false;
    currentDates.forEach((currentDate) => {
      if (date.isSame(currentDate, 'day')) {
        isDateInArr = true;
      } else {
        newDates.push(currentDate);
      }
    });

    if (!isDateInArr) {
      newDates.push(date);
    }

    setSelectedDates(newDates);
    setDateValue(newDates);
  };

  return (
    <Wrapper ref={calendarRef} className={dateError ? 'error' : ''}>
      <CalendarInput
        className={selectedDates !== undefined && selectedDates.length !== 0 ? 'selected' : ''}
        onClick={toggleCalendar}
      >
        <Label className={selectedDates !== undefined && selectedDates.length !== 0 ? 'selected' : ''}>
          <Trans id="contact.form.prefferedDates" />
        </Label>
        <Value>
          {selectedDates === undefined || selectedDates.length === 0
            ? ''
            : getFormattedDates(selectedDates, appCtx.state.lang)}
        </Value>
      </CalendarInput>
      {showCalendar && (
        <CalendarWrapper>
          <SearchMultiDaysCalendar
            selectedDates={selectedDates}
            renderedDate={renderedDate}
            onMonthChange={(month) => {
              setRenderedDate(month);
            }}
            onDateClick={(date) => {
              handleDateClick(date);
            }}
            hidePrevMonthArrow
            hideNextMonthArrow
            ref={inputRef}
            allowFuture
            blockedDates={[]}
            bottomComponents={{}}
            dayNameShortcuts={['S', 'M', 'T', 'W', 'T', 'F', 'S']}
            localeShortcut={appCtx.state.lang}
            numMonthsToShow={1}
            showHeader
            showOverlay
          />
        </CalendarWrapper>
      )}
    </Wrapper>
  );
};

export default DateInput;

const Wrapper = styled.div`
  position: relative;
`;

const CalendarInput = styled.div`
  width: 100%;
  background-color: white;
  height: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding-left: 10px;
  border-radius: 0px;
  color: #5e696a;
  background-color: #fff;
  border: solid 1px #dbdfe5;
  border-radius: 6px;
  height: 50px;
  margin-bottom: 22px;

  &.selected {
    font-weight: 600;
    color: black;
  }
  font-family: Arial;

  ${Wrapper}.error & {
    border-color: #bc350a;
    color: #bc350a;
  }
`;

const Value = styled.div`
  margin-top: 22px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const Label = styled.div`
  font-family: 'AvenirNext', 'Avenir', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
  &.selected {
    transform: translate(11px, 5px) scale(0.75);
    top: 0;
    left: 0;
    position: absolute;
    display: block;
    -webkit-transform-origin: top left;
    -moz-transform-origin: top left;
    transform-origin: top left;
    pointer-events: none;
    transform: translate(11px, 5px) scale(0.75);
    color: #8e9697;
    font-weight: 300;
  }

  &:after {
    content: ' *';
    color: #bc350a;
  }
`;

const CalendarWrapper = styled.div`
  position: absolute;
  z-index: 999;
  width: 100%;
  top: 50px;
  background-color: white;
`;
